import editor from './editor';
import option from './option';
import videoCapture from './videoCapture';

export default {
    editor,
    option,
    videoCapture
};